export const ActionTypes = {
  OPEN_MODAL: "OPEN_MODAL",
  SELECTED_MOVIE: "SELECTED_MOVIE",
  CLOSE_MODAL: "CLOSE_MODAL",
  SET_MOVIES: "SET_MOVIES",
  SELECT_MOVIE: "SELECT_MOVIE",
  SET_GENRES: "SET_GENRES",
}